import landingReducer from './landingReducer';
import modalReducer from './modalReducer';
import { combineReducers } from 'redux';

const allReducers = combineReducers({
  activeState: landingReducer,
  activeModal: modalReducer
})

export default allReducers;